import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import {useApp} from "hooks/StateHooks"
import React from "react"
import {NavLink} from "react-router-dom"
import Trans from './Trans'

const NotFound = () => (
  <div className="flex flex-col justify-center items-center w-full h-full overflow-hidden">
    <div className="">
      <NavLink to="/" className="block text-gray-800 hover:bg-gray-300 hover:text-gray-800 rounded focus:text-gray-800 px-4 py-2 w-full text-center sm:text-left flex flex-col sm:flex-row items-center sm:items-left" activeClassName="bg-gray-200 hover:bg-gray-300 rounded" exact>
        <Icon icon="home"/>
        <span className="font-semibold pl-0 sm:pl-1 whitespace-no-wrap"><Trans>Zurück zur App</Trans></span>
      </NavLink>
    </div>
    <img src={useApp().basename + '/images/undraw_page_not_found.png'} alt='page not found'/>
  </div>
)

export default NotFound
